import { Popper, ClickAwayListener, Fade, Paper, Box, Button, createTheme, Typography, ThemeProvider } from "@mui/material";
import React, { useState } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textarea } from "@mui/joy";
import CustomCurrencyTextField from "../../components/CustomCurrencyTextField";
import CustomTextField from "../../components/CustomTextField";
import DateSelector from "../../components/DateSelector";
import HistoryTable from "../../components/HistoryTable";
import MultiSelectPrimary from "../../components/MultiSelectPrimary";
import SelectBox from "../../components/SelectBox";
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import TrainingScheduleTable from "../../components/TrainingScheduleTable";
import CompetionsTable from "../../components/CompetionsTable";
import TitlesTable from "../../components/TitlesTable";
import PeriodTable from "../../components/PeriodTable";
import ClubCareerTable from "../../components/ClubCareerTable";
import InternationalClubTable from "../../components/InternationalClubTable";
import { useDispatch, useSelector } from "react-redux";
import { setIsUpdatedPlayer, setSelectedPlayer } from "../../redux/reducers/dataCaptures";
import { useTranslation } from "react-i18next";
import { formatDate, isEmpty } from "../../common/StaticExports";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '7%'
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: 13
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: 13
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    marginTop: 0
                }
            }
        }
    }
})

const PlayerDetailPage = (props:any) => {
    const { isOpen, handleClose } = props;
    const [addClubCareer, setAddClubCareer] = useState(false);
    const [addInternationalCareer, setAddInternationalCareer] = useState(false);
    const [addNewPeriod, setAddNewPeriod] = useState(false);
    const data = useSelector((state:any) => state.dataCaptures.selectedPlayer);
    const dispatch = useDispatch();
    const [t] = useTranslation();
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    const updateState = ((key:any, updatedData:any) => {
        const updatedPlayer = {
            ...data,
            [key]: updatedData,
        };
        dispatch(setSelectedPlayer(updatedPlayer));
        const boolean:any = true;
        dispatch(setIsUpdatedPlayer(boolean));
    });

    return (
            <React.Fragment>
                <ThemeProvider theme={theme}>
                <Popper className='popperStyle' open={isOpen} transition>
                        {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleClose}>
                    <Fade {...TransitionProps} timeout={350}>
                                <Paper sx={{ p: 2, width: '1200px', mt: '20px', height: '650px', overflowY: 'auto' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                        <Typography className='standardsHeading uppercase'>{t('DC_8_ACADEMY_DETAILS')}</Typography>
                                        <Box className='academyDetailsContainer'>
                                            <CustomTextField label={t('DC_8_NAME')} value={data?.name} manageChange={(e:any) => {updateState('name', e)}} isError={isEmpty(data?.name)} errorMessage={t('REQUIRED')} isDisabled={isAdmin}/>
                                            <DateSelector label={t('DC_8_DATE_OF_BIRTH')} dateValue={data?.dateOfBirth ? formatDate(data?.dateOfBirth) : null} manageChange={(e:any) => {updateState('dateOfBirth', e)}} isError={isEmpty(data?.dateOfBirth)} errorMessage={t('REQUIRED')} disabled={isAdmin} />
                                            <CustomTextField type={'number'} label={t('DC_8_ID')} value={data?.playerId} manageChange={(e:any) => {updateState('playerId', parseInt(e))}} isDisabled={isAdmin}/>
                                        </Box>
                                        </Box>
                                        <Box className='mb20 periodAtAcademyContainer'>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography className='standardsHeading uppercase'>{t('DC_8_PARIOD_AT_ACADEMY')}</Typography>
                                            {
                                                !isAdmin &&
                                                <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addNewPeriod} variant='contained' size='small' onClick={() => {setAddNewPeriod(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                    {'Add another time period'}
                                                </Button>
                                            }
                                        </Box>
                                        <Box>
                                            <PeriodTable 
                                            data={data?.academyPeriods ? data?.academyPeriods : []}
                                            addData={addNewPeriod} 
                                            handleClick={() => setAddNewPeriod(false)}
                                            updateList={(e:any) => {updateState('academyPeriods', e)}} />
                                        </Box>
                                        </Box>
                                    </Box>
                                    
                                    <Box className='mb20'>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography className='standardsHeading uppercase'>{t('DC_8_CLUB_CAREER')}</Typography>
                                            {
                                                !isAdmin &&
                                                <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addClubCareer} variant='contained' size='small' onClick={() => {setAddClubCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                    {'Add another time period'}
                                                </Button>
                                            }
                                        </Box>
                                        <Box>
                                        <ClubCareerTable 
                                        data={data?.clubCareers ? data?.clubCareers : []}
                                        addData={addClubCareer} 
                                        handleClick={() => setAddClubCareer(false)}
                                        updateList={(e:any) => {updateState('clubCareers', e)}}/>
                                        </Box>
                                    </Box>
                                    <Box className='mb20'>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography className='standardsHeading uppercase'>{t('DC_8_INTERNATIONAL_CAREER')}</Typography>
                                            {
                                                !isAdmin &&
                                                <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addInternationalCareer} variant='contained' size='small' onClick={() => {setAddInternationalCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                    {'Add another time period'}
                                                </Button>
                                            }
                                        </Box>
                                        <Box>
                                        <InternationalClubTable 
                                        data={data?.internationalCareers ? data?.internationalCareers : []}
                                        addData={addInternationalCareer} 
                                        handleClick={() => setAddInternationalCareer(false)}
                                        updateList={(e:any) => {updateState('internationalCareers', e)}}/>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Fade>
                        </ClickAwayListener>
                        )}
                    </Popper>
                </ThemeProvider>
            </React.Fragment>
    )
}

export default PlayerDetailPage;